(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["isamor-store-landing"] && !Shopify.designMode) return;
  try {
    
  function initializeIsamorLanding(root) {
    if (!root || root.dataset.isamorReady === 'true') return;
    root.dataset.isamorReady = 'true';

    const menuButton = root.querySelector('[data-isamor-menu-button]');
    const nav = root.querySelector('[data-isamor-nav]');

    function setMenu(open) {
      if (!menuButton || !nav) return;
      menuButton.setAttribute('aria-expanded', String(open));
      nav.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    }

    menuButton?.addEventListener('click', () => {
      setMenu(menuButton.getAttribute('aria-expanded') !== 'true');
    });

    nav?.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMenu(false));
    });

    root.querySelectorAll('[data-isamor-video-control]').forEach((button) => {
      const video = button.parentElement?.querySelector('video');
      if (!video) {
        button.hidden = true;
        return;
      }

      const icon = button.querySelector('span');
      const label = button.querySelector('small');
      const pauseText = button.getAttribute('aria-label');
      const playText = document.documentElement.lang.startsWith('es') ? 'Reproducir video' : 'Play video';

      function updateControl() {
        const paused = video.paused;
        button.setAttribute('aria-label', paused ? playText : pauseText);
        if (icon) icon.textContent = paused ? '▶' : 'Ⅱ';
        if (label) label.textContent = paused ? playText : pauseText;
      }

      button.addEventListener('click', async () => {
        if (video.paused) {
          try {
            await video.play();
            video.dataset.userPaused = 'false';
          } catch (error) {
            button.hidden = true;
          }
        } else {
          video.pause();
          video.dataset.userPaused = 'true';
        }
        updateControl();
      });

      video.addEventListener('play', updateControl);
      video.addEventListener('pause', updateControl);
      video.addEventListener('error', () => { button.hidden = true; });
      updateControl();
    });

    const ambientVideos = root.querySelectorAll('.isamor-landing__film-media video, .isamor-landing__video-story-media video');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      ambientVideos.forEach((video) => video.pause());
      root.querySelectorAll('[data-isamor-reveal]').forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px' });

    root.querySelectorAll('[data-isamor-reveal]').forEach((element) => observer.observe(element));

    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (video.dataset.userPaused !== 'true') video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.18 });

    ambientVideos.forEach((video) => videoObserver.observe(video));

    window.setTimeout(() => {
      root.querySelectorAll('[data-isamor-reveal]').forEach((element) => element.classList.add('is-visible'));
    }, 1600);
  }

  function initializeAllIsamorLandings(container) {
    const scope = container || document;
    if (scope.matches?.('[data-isamor-landing]')) initializeIsamorLanding(scope);
    scope.querySelectorAll?.('[data-isamor-landing]').forEach(initializeIsamorLanding);
  }

  initializeAllIsamorLandings(document);
  document.addEventListener('shopify:section:load', (event) => initializeAllIsamorLandings(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
